import React, { useState } from "react";
import "../../styles/audiobook/SelectAIVoice.scss";
import useAppTranslation from "../../hooks/useAppTranslation";

const SelectAIVoice = ({
  bookId,
  onSelect,
  onClose,
  onPrevClick,
  existingVoices,
}) => {
  const { t } = useAppTranslation("components/audiobook/selectAIVoice");
  const voiceOptions = [
    {
      id: "nikki",
      name: "니키",
      image: "/images/audiobook/nikki-recording.svg",
      nameKey: "voices.nikki.name",
      descriptionKey: "voices.nikki.description",
    },
    {
      id: "arial",
      name: "아리엘",
      image: "/images/audiobook/arial-recording.svg",
      nameKey: "voices.arial.name",
      descriptionKey: "voices.arial.description",
    },
    {
      id: "grandpa",
      name: "할아버지",
      image: "/images/audiobook/grandpa-recording.svg",
      nameKey: "voices.grandpa.name",
      descriptionKey: "voices.grandpa.description",
    },
    {
      id: "grandma",
      name: "할머니",
      image: "/images/audiobook/grandma-recording.webp",
      nameKey: "voices.grandma.name",
      descriptionKey: "voices.grandma.description",
    },
    {
      id: "witch",
      name: "마녀",
      image: "/images/audiobook/witch-recording.webp",
      nameKey: "voices.witch.name",
      descriptionKey: "voices.witch.description",
    },
  ];

  const [selected, setSelected] = useState(null);

  const handleVoiceClick = (voice) => {
    setSelected(voice);
  };

  const handleConfirm = () => {
    const selectedVoice = voiceOptions.find((v) => v.id === selected);
    const voiceName = selectedVoice?.name;
    const voiceLabel = selectedVoice ? t(selectedVoice.nameKey) : "";

    if (existingVoices?.includes(voiceName)) {
      alert(t("alerts.alreadyExists", { voice: voiceLabel }));
      return;
    }

    onSelect(voiceName);
  };

  const selectedVoice = voiceOptions.find((voice) => voice.id === selected);

  return (
    <>
      <figure className="close-select-mode" onClick={onClose}>
        <img
          src={"/images/audiobook/guide-text-close.svg"}
          alt={t("actions.close")}
        />
      </figure>
      <div className="audio-explain-container">
        <p className="step-text">{t("step")}</p>
        <h3>{t("title")}</h3>
        <p className="step-desc">{t("description")}</p>
      </div>
      <ul className="audio-selection-list w100">
        {voiceOptions.map((voice) => (
          <li
            key={voice.id}
            className={selected === voice.id ? "selected" : ""}
            onClick={() => handleVoiceClick(voice.id)}
          >
            <p>{t("voiceLabel", { voice: t(voice.nameKey) })}</p>
            <figure>
              <img src={voice.image} alt={t(voice.nameKey)} />
            </figure>
          </li>
        ))}
      </ul>
      {selected && (
        <div className="audio-desc-text">
          <div className="light-text">
            <figure>
              <img src={"/images/utils/light.svg"} alt={t("detailIconAlt")} />
            </figure>
            <h4>{t("detailTitle", { voice: t(selectedVoice?.nameKey) })}</h4>
          </div>
          <p>{selectedVoice ? t(selectedVoice.descriptionKey) : ""}</p>
        </div>
      )}
      {selected && (
        <button type="button" className="next-btn" onClick={handleConfirm}>
          <span>{t("actions.create")}</span>
        </button>
      )}
      <button type="button" className="re-select-btn" onClick={onPrevClick}>
        <img src={"/images/utils/modal/refresh.svg"} alt="" aria-hidden="true" />
        <span>{t("actions.goBack")}</span>
      </button>
    </>
  );
};

export default SelectAIVoice;
